import React from "react";
import { createRoot } from "react-dom/client";
import SiteSearch from "../components/SiteSearch";

const renderSiteSearch = ($) => {
	const searchElement = $("#js-site-search")[0];

	let isWhiteIcon =
		$("body").hasClass("page-template-rivers-index") ||
		$("body").hasClass("home") ||
		$("body").hasClass("page-template-regions-index") ||
		$("body").hasClass("error404") || 
		$("body").hasClass("page-template-take-action");

	let props = {
		...(searchElement && searchElement.dataset),
		isWhiteIcon,
	};

	if (searchElement) {
		const root = createRoot(searchElement);
		root.render(<SiteSearch {...props} />);
	}
};

export default renderSiteSearch;
